// Dashboard Layout Service - Backend API Version

import { mainApi } from '../config/apiClient';

export interface LayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  maxW?: number;
  minH?: number;
  maxH?: number;
}

export interface DashboardLayoutData {
  mainLayout: LayoutItem[];
  sideLayout: LayoutItem[];
  cardOrder: string[];
  sideCardOrder: string[];
}

export interface SaveLayoutRequest {
  userId: number;
  screenType: string;
  layout: DashboardLayoutData;
}

export interface GetLayoutResponse {
  userId: number;
  screenType: string;
  layout: DashboardLayoutData;
}

class DashboardLayoutService {
  /**
   * Layout'u backend API'den çeker
   */
  async getLayout(
    userId: number,
    screenType: string
  ): Promise<DashboardLayoutData | null> {
    try {
      const response = await mainApi.get<GetLayoutResponse>(
        `/api/DashboardLayout/GetLayout?userId=${userId}&screenType=${encodeURIComponent(screenType)}`
      );

      return response.data.layout;
    } catch (error: any) {
      if (error.response?.status === 404) {
        // Layout bulunamadı, bu normaldir (ilk kullanımda)
        console.log('Layout bulunamadı, varsayılan kullanılacak');
        return null;
      }
      console.error('Layout yükleme hatası:', error);
      throw error;
    }
  }

  /**
   * Layout'u backend API'ye kaydeder
   */
  async saveLayout(request: SaveLayoutRequest): Promise<boolean> {
    try {
      console.log('Layout kaydediliyor:', request);
      
      const response = await mainApi.post<{ success: boolean }>(
        '/api/DashboardLayout/SaveLayout',
        request
      );

      const result = response.data;
      console.log('Layout başarıyla kaydedildi:', result);
      return result.success === true;
    } catch (error) {
      console.error('Layout kaydetme hatası:', error);
      return false;
    }
  }

  /**
   * Layout'u sıfırlar (siler)
   */
  async resetLayout(
    userId: number,
    screenType: string
  ): Promise<boolean> {
    try {
      const response = await mainApi.delete<{ success: boolean }>(
        `/api/DashboardLayout/ResetLayout?userId=${userId}&screenType=${encodeURIComponent(screenType)}`
      );

      const result = response.data;
      return result.success === true;
    } catch (error) {
      console.error('Layout sıfırlama hatası:', error);
      return false;
    }
  }
}

export const dashboardLayoutService = new DashboardLayoutService();